import { sanitisePathSegment } from '../../../../utils'

type BasicVehicleInfo =
  | undefined
  | {
      make: string | undefined
      model: string | undefined
      id: string | undefined
      financeType: string | undefined
    }

export const productDetailUrl = <T extends BasicVehicleInfo>(vehicle: T) => {
  const financeType = vehicle?.financeType
    ? `?financeType=${vehicle.financeType}`
    : ''

  if (!vehicle || !vehicle.make || !vehicle.model || !vehicle.id) {
    return '/used-cars'
  }

  return `/used-cars/${sanitisePathSegment(vehicle.make)}/${sanitisePathSegment(
    vehicle.model,
  )}/details/${vehicle.id}${financeType}`
}
